// FEAT-025 — localStorage 'user' 안전 접근 헬퍼.
//
// 기존 코드는 `JSON.parse(localStorage.getItem('user')).adminid` 처럼 직접 접근하여
// localStorage 'user' 가 null/missing/잘못된 JSON 일 때 TypeError 로 thunk 가 폭발했다.
// 이 모듈을 통과한 모든 호출은 null-safe 보장.
//
// localStorage 'user' 가 null 인 케이스:
//   - 로그아웃 직후 잔여 thunk 호출
//   - 새 탭에서 admin URL 직접 접근 (login 전)
//   - 다른 탭에서 storage clear 동기화
//   - QA 에서 localStorage 수동 삭제

// 실제 읽기(getItem + JSON.parse + null-safe 흡수)는 src/lib/safeStorage.js 의
// safeGetJSON 으로 이동됨(BUG-241) — 중복 로직 제거, 반환 계약(객체 | null)은 동일.
import { safeGetJSON } from './safeStorage';

export const readSessionUser = () => safeGetJSON('user');

// adminid 만 안전하게 추출. session 부재 시 null.
export const readSessionAdminId = () => {
    const u = readSessionUser();
    return u?.adminid ?? null;
};

// session 이 없을 때 thunk 가 진행되면 안 되는 경우의 가드.
// 호출자: const adminid = readSessionAdminIdOrAbort(dispatch); if (!adminid) return;
import { AlertAction } from '../actions/AlertAction';
export const readSessionAdminIdOrAbort = (dispatch, message = 'Session expired. Please sign in again.') => {
    const adminid = readSessionAdminId();
    if (!adminid && dispatch) {
        try {
            dispatch(AlertAction.ErrorMsg(message));
        } catch {
            // alert 디스패치 실패는 swallow
        }
    }
    return adminid;
};
